import { Star, Quote } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const testimonials = [
  {
    name: "Sarah Chen",
    role: "VP of Sales",
    company: "TechScale Inc",
    avatar: "SC",
    quote: "Aiveliq360 increased our close rate by 45% in just 3 months. The AI call assist is like having a senior coach on every call.",
    rating: 5,
    metric: "45% higher close rate",
  },
  {
    name: "Michael Rodriguez",
    role: "Sales Director",
    company: "Growth Dynamics",
    avatar: "MR",
    quote: "The AI-generated proposals save my team 3 hours per deal. We're closing faster and with better margins than ever before.",
    rating: 5,
    metric: "3hrs saved per deal",
  },
  {
    name: "Emily Thompson",
    role: "Head of Revenue",
    company: "SaaS Solutions Ltd",
    avatar: "ET",
    quote: "Lead scoring accuracy is incredible. We now focus on leads that actually convert, not just the ones that look good on paper.",
    rating: 5,
    metric: "2x conversion rate",
  },
];

export function Testimonials() {
  return (
    <section className="py-12 bg-muted/30">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl lg:text-3xl font-bold mb-2">
            Loved by <span className="gradient-text">Sales Teams</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            See what sales leaders are saying about Aiveliq360
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.name}
              className="glass rounded-lg p-4 hover:border-primary/30 hover-lift transition-all duration-300 group"
            >
              <Quote className="h-6 w-6 text-primary/30 mb-3" />
              
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="h-3 w-3 fill-primary text-primary" />
                ))}
              </div>

              <p className="text-foreground text-sm mb-4 leading-relaxed">
                "{testimonial.quote}"
              </p>

              <div className="inline-block px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs font-medium mb-4">
                {testimonial.metric}
              </div>

              <div className="flex items-center gap-2 pt-3 border-t border-border">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-primary/10 text-primary text-xs">
                    {testimonial.avatar}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <p className="font-medium text-sm">{testimonial.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
